"use strict";

angular.module('app.models.sceneConditionData', []). //

factory('__SceneConditionData', function(restmod, xCenterConfig) {
    'ngInject';
    
    return restmod.model('/Scene').mix('BaseModel').mix({

        _type: {
            map: '$type'
        },
        $hooks: {
            'after-feed': function(data) {
                this.prepareCondition();
            },
            'prepare-condition-data': function() {
                this.prepareCondition();
            }
        },
        /* Prepare Condition Tree */

        prepareCondition: function() {
            if (this.$UI == undefined) {
                this.$UI = {};
            }
            //   console.log('Prepare Condition Data');

            if (!this.TimeoutMs || this.TimeoutMs < 0) {
                this.TimeoutMs = 0;
            }
            /*if (!this.TimeoutMs  || this.TimeoutMs < 0) {
                this.TimeoutMs = 0;
            };
            if (!this.TimeoutMs  || this.TimeoutMs < 0) {
                this.TimeoutMs = 0;
            };*/
            // ConditionData
            /*if (ParentCondition) {
             Condition.UI.$Type = ParentCondition.UI.$Type;
             }*/
            this.$UI.NewConditionList = [];
            switch (this._type) {
                case "BMS.Shared.SceneData.Conditions.SceneDataConditionNumericCompare, BMS.Shared":
                    //
                    this.$UI.ConditionType = 'CompareCondition';
                    this.prepareCondition_NumericCondition();

                    break;
                case "BMS.Shared.SceneData.Conditions.SceneDataConditionTimeProgram, BMS.Shared":
                    //
                    this.$UI.ConditionType = 'TimeCondition';
                    this.prepareCondition_TimeProgram();

                    break;
            }

        },
        prepareCondition_TimeProgram: function() {

            //
            // Add UI to every WeekTimeProgram
            function isBefore(a, b) {
                return moment(a).isSameOrBefore(b);
            }
            if (this.TimeProgram.WeekProgramEntries != null) {

                var calculatePixel = function(entry) {

                    var sec = moment(entry.End).diff(entry.Start, 'seconds');
                    var left = moment(entry.Start).diff(moment(entry.Start).startOf('day'), 'seconds');

                    // On day in seconds = 86400
                    //var dStart = new moment(start).utc().set({date:1,month:0,year:0});
                    //var dEnd = new moment(end).utc().set({date:1,month:0,year:0});


                    var o = {
                        "left": (left / 86400) * 100,
                        "width": (sec / 86400) * 100
                    };

                    const wpe = entry;
                    let gradArr = [];
                    /* Background calculated for css. */
                    /* This calculation is for return to the scene detail edit mode after from the edit modal dialog. */
                    let percent = (o.width / 68) * 84;
                    if (percent > 84) {
                        percent = 84;
                    }
                    if (wpe.AstroTypeStart === 1) {
                        gradArr.push('linear-gradient(-135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, red 100%)');
                    } else if (wpe.AstroTypeStart === 2) {
                        gradArr.push('linear-gradient(-135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, blue 100%)');
                    }

                    if (wpe.AstroTypeEnd === 1) {
                        gradArr.push('linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, red 100%)');
                    } else if (wpe.AstroTypeEnd === 2) {
                        gradArr.push('linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, blue 100%)');
                    }

                    gradArr.push('linear-gradient(to right, rgba(168,203,48,1) 0%, rgba(168,203,48,1) 20%,rgba(168,203,48,1) 80%, rgba(168,203,48,1) 100%)');

                    o.background = gradArr.join();

                    return o;
                };

                for (var i = 0; i < this.TimeProgram.WeekProgramEntries.length; i++) {
                    this.TimeProgram.WeekProgramEntries[i].$UI = {};
                    var pos = calculatePixel(this.TimeProgram.WeekProgramEntries[i]);

                    this.TimeProgram.WeekProgramEntries[i].$UI.left = pos.left;
                    //this.TimeProgram.WeekProgramEntries[i].$UI.weekday = pos.left;
                    this.TimeProgram.WeekProgramEntries[i].$UI.width = pos.width;
                    this.TimeProgram.WeekProgramEntries[i].$UI.background = pos.background;
                }

            }
        },
        prepareCondition_NumericCondition: function() {


            if (this.Data.UI == undefined) {
                this.Data.UI = {};
            }
            var ConditionData = this;

            if (ConditionData.DataToCompare._type == 'BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared') {

                switch (ConditionData.DataToCompare.DatapointType) {
                    case 0:
                        ConditionData.DataToCompare.ConstantValue = parseInt(ConditionData.DataToCompare.ConstantValue);

                        break;
                    case 1:
                        ConditionData.DataToCompare.ConstantValue = parseFloat(ConditionData.DataToCompare.ConstantValue);

                        break;
                    case 2:
                        if (typeof ConditionData.DataToCompare.ConstantValue == 'boolean') {
                            break;
                        }
                        ConditionData.DataToCompare.ConstantValue = ConditionData.DataToCompare.ConstantValue == "True" ? true : false;

                        break;
                }
            }
            if (ConditionData.$UI && ConditionData.$UI.$Datapoint && ConditionData.$UI.$Datapoint.DatapointConfig) {
                if (ConditionData.$UI.$Datapoint.DatapointConfig.PossibleValues != null) {
                    ConditionData.DataToCompare.ConstantValueRead = ConditionData.$UI.$Datapoint.DatapointConfig.PossibleValues[ConditionData.ConstantValue];
                } else {
                    ConditionData.DataToCompare.ConstantValueRead = ConditionData.DataToCompare.ConstantValue + ' ' + ConditionData.$UI.$Datapoint.DatapointConfig.Unit;
                }
            }

        },




    });
});
